import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic/LogicEvents';
import { SingleSetPromotionStates, SingleSetPromotionModule } from '@gongxigames/framework/promotions';

export class SingleSetPromotionBasicState extends ModuleState<null, SingleSetPromotionModule, GlobalEventsMapForBackwardCompatibility> {
    protected setupEvents(): void {
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.onResponse.bind(this));
    }

    private onResponse(): void {
        if (this.module.getPromotion().hasPromotion() && this.module.nextActionIsSpin) {
            this.emit('General.Slot.SPIN.DISABLE', SingleSetPromotionModule.NAME);
        }
    }
    private onPaidRoundEnded(): void {
        this.checkStartPromotion();
    }

    public onEnterState(): void {}
    public onLeaveState(): void {}

    private checkStartPromotion(): void {
        if (this.module.getPromotion().hasPromotion() && this.module.nextActionIsSpin) {
            this.module.gotoState(SingleSetPromotionStates.START);
        }
    }
}
